<template>
  <div class="threeShop" ref="threeShop">
    <div class="softMarketTop">
      <div class="softMarketTopSearch">
        <div class="logoTitle">
          <div class="logoTitle1">
            3D商城
            <p
              style="
                font-size: 12px;
                color: rgb(219, 219, 219);
                text-transform: uppercase;
              "
            >
              3D MALL
            </p>
          </div>
          <div class="logoTitle2" @click="getShopList">全部商品</div>
        </div>
        <div class="searchContainer">
          <div class="flex searchContainerone">
            <el-input
              placeholder="请输入内容"
              v-model="searchValue"
              class="input-with-select"
              @keyup.native.enter="getShopList"
            >
              <el-button slot="append" @click="getShopList">
                <i class="el-icon-search" style="font-size: 24px"></i>
              </el-button>
            </el-input>
            <!-- @click="toServiceAuthentication" -->
            <button
              plain
              class="searchContainerButton"
              @click="toServiceAuthentication"
            >
              商家入驻
            </button>
          </div>

          <ul>
            <li
              class="textLi"
              @click="searchByKeyword(items)"
              v-for="(items, index) in keywords"
            >
              {{ items }}
            </li>
          </ul>
        </div>
        <div class="shoppingCar" v-if="isShow">
          <el-badge :value="goodsNum" class="item">
            <el-button
              size="small"
              icon="el-icon-shopping-cart-full"
              @click="$router.push('shopCar')"
              >我的购物车</el-button
            >
          </el-badge>
        </div>
      </div>
    </div>
    <div class="softMarketBanner">
      <div class="bannerContainer" @mouseleave="leave()">
        <div>
          <div class="bannerContainerLeft">
            <div class="softMarketClassifyContainer">
              <ul>
                <li
                  v-if="firstList.length > 0"
                  v-for="(item, index) in firstList"
                  :key="index"
                >
                  <p
                    @mouseenter="btnChoose(item.value, item.children)"
                    @click="handGoodsList(item.value)"
                  >
                    {{ item.label }} <i class="el-icon-arrow-right"></i>
                  </p>
                  <div class="secondItem">
                    <div
                      v-if="item.children.length > 0"
                      v-for="(items, indexs) in item.children"
                      :key="indexs"
                      @click="handGoodsList(item.value, items.value)"
                    >
                      <span> {{ items.label }} </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div>
              <div class="softMarketDetails" v-show="show">
                <div
                  v-for="(item, index) in firstLists"
                  :key="index"
                  class="softMarketList"
                >
                  <div class="secondName">
                    <span @click="handGoodsList(firstUuids, item.value)">{{
                      item.label
                    }}</span>
                  </div>
                  <div class="threeName">
                    <div v-for="(items, index) in item.children" :key="index">
                      <span
                        @click="
                          handGoodsList(firstUuids, item.value, items.value)
                        "
                        >{{ items.label }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bannerContainerCenter">
          <div class="bannerContainerTop" style="cursor: pointer">
            <el-carousel trigger="click" height="360px">
              <el-carousel-item v-for="item in bannerList" :key="item.value">
                <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">
                  <img :src="item.value" alt="" style="width: 698px; height: 360px" ref="image"/>
                </a>
                <a v-else href="javascript:void(0)">
                  <img :src="item.value" alt="" style="width: 698px; height: 360px" ref="image"/>
                </a>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="bannerContainerCenterImg" style="cursor: pointer">
          <a :href="rightTopBannerLink" target="_blank"><img :src="rightTopBanner" alt="" /></a>
          <a :href="rightBottomBannerLink" target="_blank"><img :src="rightBottomBanner" alt="" /></a>
        </div>
      </div>
    </div>
    <!-- 人气推荐 -->
    <div class="swiperTop dmessages" ref="newmess">
      <div class="flex swiperTopTitle">
        <h2>人气推荐</h2>
        <div class="flex peopelMess">
          <i class="el-icon-arrow-left" @click="sentimenClick('left')"></i>
          <i class="el-icon-arrow-right" @click="sentimenClick('right')"></i>
        </div>
      </div>
      <div class="dmessagesBottom" ref="dmessageRef">
        <div
          class="dmessagesBottombox"
          @click="handGoodsDetails(goods.uuid)"
          v-for="(goods, goodsIndex) in sentimentList"
          :key="goodsIndex"
        >
          <img :src="goods.imgUrl" alt="" />
          <div class="sdmessagesbotMes">
            <el-tooltip
              class="item"
              effect="dark"
              :content="goods.name"
              placement="bottom"
            >
              <h4>{{ goods.name }}</h4>
            </el-tooltip>
            <p>{{ goods.shopName }}</p>
            <span>¥{{ goods.minPrice }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 3D打印配件 -->
    <div
      class="dmessages"
      ref="accessories"
      v-for="(item, index) in tabsNap"
      :key="index"
    >
      <div class="flex swiperTopTitle">
        <!-- <h2 style="margin-top: 15px" class="titleTit">{{ item.categoryUuid===''?'人气推荐':item.categoryName }}</h2> -->
        <h2 style="margin-top: 15px" class="titleTit">
          {{ item.categoryName }}
        </h2>
        <div class="flex titleRight" v-if="item.categoryList.length > 0">
          <span
            v-for="(category, categoryIndex) in item.categoryList"
            @click="handGoodsList(category.parentUuid, category.uuid)"
            :key="categoryIndex"
          >
            {{ category.name }}
            <span
              class="titleXie"
              v-if="categoryIndex + 1 < item.categoryList.length"
              >/</span
            >
          </span>
          <!-- <i class="el-icon-arrow-right" @click="handGoodsList(item.categoryUuid)"></i> -->
          <div @click="handGoodsList(item.categoryUuid)" class="titleMore">
            查看更多 >
          </div>
        </div>
        <div class="flex titleRight" v-else>
          <!-- <i class="el-icon-arrow-right" @click="handGoodsList()"></i> -->
          <div class="titleMore" @click="handGoodsList()">查看更多 ></div>
        </div>
      </div>
      <div
        class="dmessagesImg"
        v-if="item.fileList.length > 0"
        v-for="(file, indexs) in item.fileList"
        :key="indexs"
      >
        <img :src="file.path" alt="" @click="openNewPage(file.linkUrl)" />
      </div>
      <div style="margin: 28px 0 31px 0" v-if="item.fileList.length == 0"></div>
      <!--<div class="swiper-container" v-if="item.categoryUuid===''">
                <div class="swiper-wrapper">
                    <div
                            class="swiper-slide"
                            @click="handGoodsDetails(goods.uuid)"
                            v-for="(goods, goodsIndex) in item.goodsList"
                            :key="goodsIndex"
                    >
                        <div>
                            <img :src="goods.imgUrl" alt=""/>
                            <div class="swiper-slideMess">
                                <h4>{{ goods.name }}</h4>
                                <p>{{ goods.shopName }}</p>
                                <span>¥{{ goods.minPrice }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->

      <div class="dmessagesBottom">
        <div
          class="dmessagesBottombox"
          @click="handGoodsDetails(goods.uuid)"
          v-for="(goods, goodsIndex) in item.goodsList"
          :key="goodsIndex"
        >
          <img :src="goods.imgUrl" alt="" />
          <div class="sdmessagesbotMes">
            <el-tooltip
              class="item"
              effect="dark"
              :content="goods.name"
              placement="bottom"
            >
              <h4>{{ goods.name }}</h4>
            </el-tooltip>
            <!-- <h4>{{ goods.name }}</h4> -->
            <p>{{ goods.shopName }}</p>
            <span>¥{{ goods.minPrice }}</span>
          </div>

        </div>
      </div>
    </div>
    <!-- 优质商家 -->
    <div class="goods" ref="merchants">
      <div class="goodsbox">
        <div class="flex swiperTopTitle">
          <h2>优质商家</h2>
          <!-- <i class="el-icon-arrow-right" @click="handMallList"></i> -->
          <div class="titleMore" @click="handMallList">查看更多 ></div>
        </div>
        <div class="goodsImg flex">
          <div
            v-for="(items, index) in merchants"
            :key="index"
            class="goodsImgBox"
          >
            <img
              :src="items.logo"
              v-if="items.logo != ''"
              alt=""
              @click="
                goToDetail(
                  items.storeUuid,
                  items.storeUuid,
                  items.enterpriseUuid
                )
              "
            />
            <img
              src="../../assets/storeLogo.jpeg"
              v-else
              alt=""
              @click="
                goToDetail(
                  items.storeUuid,
                  items.storeUuid,
                  items.enterpriseUuid
                )
              "
            />
			<div class="mask">
			    <div class="maskContent">
			        <p style="font-size: 14px; ">{{ items.enterPriseName }}</p>
			        <p
			            style="
			                font-size: 12px;
			                color: #fff;
			                display: flex;
			                padding: 5px 10px 0"
			        >
			            <span>好评度：</span>
			            <el-rate
			                v-model="items.star"
			                disabled
			                :colors="colors"
			            ></el-rate>
			        </p>
			    </div>
			</div>
          </div>

          <!-- <img src="" alt="" class="goodsImgbox"/>
                    <img src="" alt="" class="goodsImgbox"/>
                    <img src="" alt="" class="goodsImgbox"/>
                    <img src="" alt="" class="goodsImgbox"/> -->
        </div>
      </div>
    </div>
    <div class="topNapbox" v-show="isScroll">
      <div class="topNap">
        <!--<p
                    @click="getTitleDistance(index)"
                    :class="distanceIndex === 0?'active':''"
                >
                    人气推荐
                </p>-->
        <p
          @click="getTitleDistance(index)"
          v-for="(items, index) in tabsNap"
          :class="distanceIndex === index ? 'active' : ''"
          :key="index"
        >
          {{ items.categoryName == "" ? "人气推荐" : items.categoryName }}
        </p>
        <p
          @click="getTitleDistance(tabsNap.length)"
          :class="distanceIndex === tabsNap.length ? 'active' : ''"
        >
          优质商家
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getShopList,
  getNewcurrent,
  designerByUserId,
  findRecommendList,
  getShopRecommendList,
  getShopCarNumber,
  getShopRecommendDetail,
  typeTree,
  getDictionaryItem,
} from "../../utils/interface";
import Swiper from "swiper";
import { mapState, mapMutations } from "vuex";
import { forEach } from "jszip";
export default {
  //   3D商城
  name: "threeShop",
  metaInfo: {
    title: '3D打印产品交易平台——增材云3D商城|3D打印商品买卖', // set a title
    meta: [{                 // set meta
      name: 'keywords',
      content: '3D打印|3D打印机|3D打印原料|金属3D打印机|桌面3D打印机|光敏树脂|陶瓷|线材|送礼摆件|陶瓷3D打印|砂型'
    },{                 // set meta
      name: 'description',
      content: '3D打印行业商品买卖平台，制造商直接供货，没有中间商赚差价。对接一手货源，享集采优惠价。增材云，聚合3D打印设计师、3D打印厂商、3D打印原料、3D打印模型、3D打印软件及课程等6大资源。'
    }],
  },
  components: {},
  data() {
    return {
		colors: ["#da251d", "#da251d", "#da251d"],
      keywords: [],
      show: false,
      //二级分类列表
      firstLists: [],
      firstUuids: "",
      bannerList: [],
      searchValue: "",
      distanceIndex: 0,
      isScroll: false,
      setIn: null,
      tabsNap: [],
      // 优质商家
      merchants: [],
      // 商家入驻信息
      identity: "",
      firstList: [],
      rightTopBanner: "",
      rightBottomBanner: "",
      rightTopBannerLink: "",
      rightBottomBannerLink: "",
      isShow: false,
      goodsNum: 0,
      sentimentList: [],
      num: 0,
    };
  },
  mounted() {
    this.handSwiper();
    window.addEventListener("scroll", this.handleScroll, true);
  },
  created() {
    this.getShopCarNumber();
    this.getShopRecommendList();
    this.findRecommendList();
    this.getShopCategoryList();
    getDictionaryItem({ groupCode: "shop_keyword" }).then((res) => {
      if (res != null && res.length > 0) {
        res.forEach((item, index) => {
          this.keywords.push(item.name);
        });
      }
    });
    getDictionaryItem({ groupCode: "SHOP_BANNER" }).then((res) => {
      this.bannerList = res;
    });
    getDictionaryItem({ groupCode: "SHOP_BANNER_RIGHT_TOP" }).then((res) => {
      if (res.length > 0) {
        this.rightTopBanner = res[0].value;
        this.rightTopBannerLink = res[0].linkUrl;
      }
    });
    getDictionaryItem({ groupCode: "SHOP_BANNER_RIGHT_BOTTOM" }).then((res) => {
      if (res.length > 0) {
        this.rightBottomBanner = res[0].value;
        this.rightBottomBannerLink = res[0].linkUrl;
      }
    });
    // this.setIn = setInterval(() => {
    //   if (this.isTokenDoor === true) {
    //     clearInterval(this.setIn);
    //   }
    // }, 500);
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
      isLogin: "isLogin",
    }),
  },
  methods: {
    sentimenClick(type) {
      if (this.sentimentList.length <= 5) {
        return;
      }
      if (type == "left") {
        ++this.num;
      } else {
        --this.num;
      }

      if (this.sentimentList.length -5 < this.num) {
          this.num = --this.num
        return;
      }
      if (this.num == -1) {
          this.num = ++this.num
          return
      }
      console.log("num", this.num);


      if (type == "left") {
        let leftNum = this.num * -246 + "px";
        this.$refs.dmessageRef.style.transform = `translate(${leftNum},0)`;
        console.log(
          "this.$refs.dmessageRef.style",
          this.$refs.dmessageRef.style.transform
        );
      } else if (type == "right") {
        let rightNum = this.num * -246 + "px";

        this.$refs.dmessageRef.style.transform = `translate(${rightNum},0)`;
        console.log(
          "this.$refs.dmessageRef.style",
          this.$refs.dmessageRef.style.transform
        );
      }
    },
    getShopCarNumber() {
      if (this.isLogin) {
        this.isShow = true;
        getShopCarNumber().then((res) => {
          if (res.success) {
            this.goodsNum = res.data;
          }
        });
      } else {
        this.isShow = false;
      }
    },
    searchByKeyword(keyword) {
      this.searchValue = keyword;
      let routeData = this.$router.resolve({
        name: "shopGoodsList",
        query: { keywords: this.searchValue },
      });
      window.open(routeData.href, "_blank"); // 新窗口打开外链接
    },
    getShopList() {
      let routeData = this.$router.resolve({
        name: "shopGoodsList",
        query: {
          keywords: this.searchValue,
        },
      });
      console.log(JSON.stringify(routeData));
      window.open(routeData.href, "_blank"); // 新窗口打开外链接
    },
    btnChoose(uuid, item) {
      this.firstUuids = uuid;
      this.firstLists = [];
      this.show = true;
      this.firstLists = item;
    },
    leave() {
      this.show = false;
      this.firstUuids = "";
      this.firstLists = [];
    },
    // getShopRecommendList(){
    //     getShopRecommendList().then((res)=>{
    //         res.forEach(item=>{
    //             getShopRecommendDetail(item.uuid).then((result=>{
    //                 // this.$set(item, "goodsList", result);
    //                 item.goodsList = result
    //                 console.log('result', result);
    //             }));
    //         });
    //         // let sentimentListMess = res.splice(0,1)
    //         let sentimentListMess = res[0]

    //         // this.sentimentList = res.splice(0,1)[0].goodsList
    //         console.log('this.sentimentList',res[0]);

    //         console.log('this.sentimentList',sentimentListMess.goodsList);

    //         this.tabsNap = res
    //     });
    // },
    async getShopRecommendList() {
      let arr = [];
      let res = await getShopRecommendList();
      res.forEach((item) => {
        let result = getShopRecommendDetail(item.uuid);
        arr.push(result);
        // this.$set(item, "goodsList", result);
        // item.goodsList = result
        console.log("result", result);
      });
      let allList = await Promise.all(arr);
      //    console.log(111, values);
      allList.forEach((item, index) => {
        res[index].goodsList = item;
      });
        this.sentimentList = res[0].goodsList;

      let sentimentListMess = res.splice(0, 1);

      this.tabsNap = res;
    },
    getShopCategoryList() {
      let params = {
        grade: "3",
        type: "PLATFORM",
      };
      typeTree(params).then((res) => {
        this.firstList = res;
        // console.log(this.firstList)
      });
    },
    findRecommendList() {
      let params = {
        current: 1,
        pageSize: 18,
        isRecommend: 1,
      };
      findRecommendList(params).then((res) => {
        this.merchants = res.list;
      });
    },
    ...mapMutations(["isLoginVuex"]),
    // 判断当前用户是否可以进行商家
    // 商家入驻
    toServiceAuthentication() {
      if(this.$store.state.isLogin) {
        getNewcurrent().then((data) => {
          designerByUserId(data.uuid).then((res)=>{
            if (res != null && res !== "") {
              this.$message({
                type: "error",
                message: "您已申请平台设计师，无法申请入驻店铺！",
              });
              return false;
            }else {
              this.identity = data.identity;
              if (this.identity === 'ENTERPRISE') {
                this.$router.push({
                  name: "shopServiceAuthentication",
                });
              } else if (this.identity === 'PERSONAL' || this.identity === 'ANONYMOUS') {
                this.$confirm('请先进行企业资质认证!', '提示', {
                  confirmButtonText: '去认证',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  window.sessionStorage.setItem("userServeId", "11");
                  let routeData = this.$router.resolve({
                    name: "userCenter",
                    params: {
                      userServeId: '11',
                    },
                  });
                  window.open(routeData.href, "_target");
                });
              }
            }
          });
        });
      } else {
        this.$message({
          type: "error",
          message: "您需要先登录哦！",
        });
        this.$router.push("/login");
        return false;
      }
    },
    handSwiper() {
      new Swiper(".swiper-container", {
        // slidesPerView: 5,
        // spaceBetween: 30,
        // slidesPerGroup: 3,
        // loop: true,
        // loopFillGroupWithBlank: true,
        // // 如果需要分页器
        // pagination: {
        //   el: ".swiper-pagination",
        // },

        slidesPerView: 5, //显示个数
        pagination: {
          el: ".swiper-pagination",
        },
        // // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
    getTitleDistance(i) {
      this.distanceIndex = i;
      if (i < this.tabsNap.length) {
        this.tabsNap.map((item, index) => {
          if (i == index) {
            window.scrollTo({
              top: this.$refs.accessories[index].offsetTop - 80,
              behavior: "smooth",
            });
          }
        });
      } else {
        let merchants = this.$refs.merchants;
        window.scrollTo({
          top: merchants.offsetTop - 80,
          behavior: "smooth",
        });
      }
    },
    // 商品列表
    handGoodsList(firstUuid, secondUuid, thirdUuid) {
      let routeData;
      if (firstUuid == undefined && secondUuid == undefined) {
        routeData = this.$router.resolve({
          name: "shopGoodsList",
        });
      } else {
        routeData = this.$router.resolve({
          name: "shopGoodsList",
          params: {
            uuid: firstUuid,
            secondUuid: secondUuid,
            thirdUuid: thirdUuid,
          },
        });
      }
      window.open(routeData.href, "_blank");
    },
    openNewPage(linkUrl) {
      window.open(linkUrl, "_target");
    },
    // 商品详情
    handGoodsDetails(uuid) {
      let routeData = this.$router.resolve({
        name: "shopGoodDetails",
        params: { uuid: uuid },
      });
      window.open(routeData.href, "_blank");
    },
    // 商城列表
    handMallList() {
      let routeData = this.$router.resolve({
        name: "shopMallList",
        params: { url: "shopMallList" },
      });
      window.open(routeData.href, "_blank");
    },
    // 进店看看
    goToDetail(uuid, storeUuid, enterpriseUuid) {
      // uuid 店铺信息
      // enterPriseUuid 企业id
      // 跳转到详情页
      let routeData = this.$router.resolve({
        name: "printServiceIndex",
        params: {
          uuid: uuid,
          storeUuid: storeUuid,
          enterPriseId: enterpriseUuid,
        },
      });
      window.open(routeData.href, "_blank");
    },
    // 滚动固定导航栏
    handleScroll() {
      this.$nextTick(() => {
        // 获取所有锚点元素
        const divs = [...document.querySelectorAll(".titleTit")];
        // 所有锚点元素的 offsetTop
        // console.log(divs)
        const offsetTopArr = [];
        // 将所有锚点元素offsetTop push到数组内
        divs.forEach((item) => {
          offsetTopArr.push(item.offsetTop);
        });
        // 获取当前文档流的 scrollTop
        const scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        // 定义当前点亮的导航下标
        let navIndex = 0;
        for (let n = 0; n < offsetTopArr.length; n++) {
          // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
          // 那么此时导航索引就应该是 n 了
          if (scrollTop >= offsetTopArr[n]) {
            navIndex = n;
          }
        }
        // 把下标赋值给 vue 的 data
        this.distanceIndex = navIndex;

        // let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        //变量windowHeight是可视区的高度
        let windowHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
        //变量scrollHeight是滚动条的总高度
        let scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight;
        if (scrollTop > 450 && scrollTop + windowHeight < scrollHeight) {
          this.isScroll = true;
        } else {
          this.isScroll = false;
        }
        if (
          this.$refs.newmess &&
          this.$refs.equipment &&
          this.$refs.accessories &&
          this.$refs.consumables &&
          this.$refs.goods &&
          this.$refs.merchants
        ) {
          let detailsTops1Height = this.$refs.newmess.offsetHeight;
          let detailsTops2Height = this.$refs.equipment.offsetHeight;
          let detailsTops3Height = this.$refs.accessories.offsetHeight;
          let detailsTops4Height = this.$refs.consumables.offsetHeight;
          let detailsTops5Height = this.$refs.goods.offsetHeight;
          if (scrollTop > 450 && scrollTop < 480 + detailsTops1Height) {
            this.distanceIndex = 0;
          } else if (
            scrollTop > 480 + detailsTops1Height &&
            scrollTop < 530 + detailsTops1Height + detailsTops2Height
          ) {
            this.distanceIndex = 1;
          } else if (
            scrollTop > 530 + detailsTops1Height + detailsTops2Height &&
            scrollTop <
              600 + detailsTops1Height + detailsTops2Height + detailsTops3Height
          ) {
            this.distanceIndex = 2;
          } else if (
            scrollTop >
              600 +
                detailsTops1Height +
                detailsTops2Height +
                detailsTops3Height &&
            scrollTop <
              680 +
                detailsTops1Height +
                detailsTops2Height +
                detailsTops3Height +
                detailsTops4Height
          ) {
            this.distanceIndex = 3;
          } else if (
            scrollTop >
              680 +
                detailsTops1Height +
                detailsTops2Height +
                detailsTops3Height +
                detailsTops4Height &&
            scrollTop <
              750 +
                detailsTops1Height +
                detailsTops2Height +
                detailsTops3Height +
                detailsTops4Height +
                detailsTops5Height
          ) {
            this.distanceIndex = 4;
          } else {
            this.distanceIndex = 5;
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.threeShop {
  // position: relative;
}

.softwareVendor {
  .softwareVendorTitle {
    text-align: center;
    margin-bottom: 30px;

    .printTitle {
      margin: 0;
      font-size: 24px;
      font-weight: bold;
      color: #2d2d2d;
    }

    .partnersPartClass {
      display: flex;
      align-items: center;
      width: 218px;
      margin: 0 auto;

      .line {
        width: 62px;
        height: 2px;
        background: #aaa;
      }

      .name {
        font-size: 16px;
        padding: 0 15px;
        color: #aaa;
        font-weight: normal;
      }
    }
  }

  /deep/ .el-col-4 {
    padding-left: 6px !important;
    padding-right: 6px !important;
  }

  /deep/ .el-row {
    margin: 0 !important;
  }
}

.softMarketTop {
  width: 100%;
  // height: 110px;
  background: #fff;
  box-sizing: border-box;

  .softMarketTopSearch {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    padding-top: 18px;
    // padding-bottom: 18px;
    box-sizing: border-box;

    .logoTitle {
      font-size: 18px;
      // line-height: 74px;
      color: #157efb;
      font-weight: bold;

      .logoTitle1 {
        height: 40px;
        color: #000;
      }

      .logoTitle2 {
        background: #000;
        height: 40px;
        color: #fff;
        line-height: 40px;
        width: 246px;
        padding-left: 20px;
        box-sizing: border-box;
        margin-top: 6px;
        font-weight: 400;
        cursor: pointer;
      }
    }

    .searchContainer {
      // width: 690px;
      margin: 0 auto;
      padding: 0 15px;

      .searchContainerone {
        .input-with-select {
          flex-shrink: 0;
        }

        .searchContainerButton {
          color: #157efb;
          margin-left: 15px;
          border: 1px solid #157efb;
          width: 88px;
          background: #fff;
          font-size: 14px;
          border-radius: 10px;
          cursor: pointer;
        }
      }

      /deep/ .input-with-select .el-input__inner {
        border: 2px solid #157efb;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        background: #fdfdfd;
        height: 40px;
        line-height: 40px;
      }

      /deep/ .el-input-group {
        height: 40px;
        width: 618px;
      }

      /deep/ .input-with-select .el-input-group__append {
        background: #157efb;
        color: #fff;
        border: 1px solid #157efb;
        border-left: none;
        border-radius: 0px 10px 10px 0px;
        width: 80px;
        box-sizing: border-box;
        text-align: center;
      }

      ul {
        display: flex;
        color: #c0c0c0;
        padding-left: 3px;

        li {
          font-size: 12px;
          padding: 8px 20px 0 0;

          &.textLi {
            padding: 10px 20px 0 0;
            cursor: pointer;

            &:hover {
              color: #157efb;
            }
          }
        }
      }
    }
    .shoppingCar {
      margin-top: 6px;
    }
  }
}

.softMarketBanner {
  width: 100%;
  height: 362px;
  background: url("../../assets/image/BannerBg.png") no-repeat center center;
  background-size: cover;
  box-shadow: 0 0 25px 2px #bbbbbb57;

  .bannerContainer {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    //  .bannerContainerLeft:hover .softMarketDetails{
    //         display: block;
    //     }
    .bannerContainerLeft {
      width: 246px;
      height: 362px;
      position: relative;
      box-sizing: border-box;

      .softMarketDetails {
        width: 658px;
        height: 320px;
        background-color: white;
        position: absolute;
        top: 0;
        left: 256px;
        z-index: 999;
        padding: 20px;
        cursor: pointer;
        // display: none;
        .softMarketList {
          display: flex;
          // align-items: center;
          flex-wrap: wrap;
          margin-bottom: 10px;
          font-size: 14px;

          .secondName {
            width: 100px;
            margin-right: 5px;
            color: #131313;
            text-align: left;
            span:hover {
              color: #157efb;
            }
            span {
              cursor: pointer;
            }
          }
          .threeName {
            width: 500px;
            display: flex;
            flex-wrap: wrap;
            cursor: pointer;
            span:hover {
              color: #157efb;
            }
            div {
              margin-right: 20px;
              margin-bottom: 10px;
              color: #c2c4c7;
            }
          }
        }
      }
      .softMarketClassifyTop {
        width: 100%;
        color: #fff;
        background: #063975;
        height: 362px;
        padding: 0 15px;
        line-height: 50px;
        box-sizing: border-box;
        font-size: 18px;
        font-weight: bold;
      }

      .softMarketClassifyContainer {
        width: 246px;
        height: 362px;

        ul {
          width: 246px;
          height: 362px;
          background: #ffffff;
          // padding: 12px 21px;
          padding: 12px 8px;
          box-sizing: border-box;

          li {
            font-weight: 400px;
            margin-bottom: 17px;
            // display: flex;
            // align-items: center;
            .secondItem {
              display: flex;
              // width: 122px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              span {
                margin-right: 5px;
                color: #c2c4c7;

                &:hover {
                  color: #157efb;
                }
              }
            }
            p {
              font-size: 14px;
              cursor: pointer;

              &:hover {
                color: #157efb;
              }
            }

            span {
              font-size: 12px;
              color: #131313;
              cursor: pointer;
            }
          }

          li:nth-last-of-type(1) {
            margin-bottom: 0;
          }
        }
      }
    }

    .bannerContainerCenter {
      width: 698px;
      // padding: 14px 0;
      flex-shrink: 0;
      box-sizing: border-box;
      position: relative;
      /deep/ .el-carousel__indicator {
        button {
          opacity: 1;
          background: #fff;

          &:hover {
            background: #f00;
          }
        }

        &.is-active {
          button {
            background: #f00;
          }
        }
      }

      .bannerContainerBottom {
        display: flex;
        padding-top: 17px;
        justify-content: space-between;
        flex-wrap: wrap;

        img {
          width: 218px;
          height: 88px;
          // margin-right: 6px;
        }

        .bannerContainerBottomimg {
          width: 218px;
          height: 0;
        }
      }
    }

    .bannerContainerCenterImg {
      width: 236px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      img {
        width: 236px;
        height: 174px;
        background: #efefef;
      }
    }

    .box-card {
      border: 1px solid #e3e3e3;
      margin-bottom: 30px;
      font-size: 12px;

      h2 {
        font-size: 16px;
        margin-bottom: 5px;
      }

      .sDetail {
        font-size: 12px;
        margin: 15px auto;
        text-align: left;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        color: #858993;
      }

      .sPrice {
        font-size: 16px;
        color: #da251d;
        margin-bottom: 15px;

        span {
          font-size: 12px;
        }
      }

      .image {
        width: 64px;
        height: 64px;
        margin-top: 15px;
      }
    }
  }
}

.swiperTop {
  width: 1245px;
  margin: 0 auto;
  position: relative;
  margin-bottom: 65px;

  .swiperTopTitle {
    justify-content: space-between;
    align-items: center;
    margin: 28px 0 28px 22px;
    // border-bottom: 1px solid #e3e3e3;
    box-sizing: border-box;

    h2 {
      font-size: 16px;
      color: #1f82f7;
      padding-bottom: 10px;
      border-bottom: 1px solid #157efb;
    }

    .peopelMess {
      i {
        border: 1px solid #1f82f7;
        display: inline-block;
        padding: 5px;
        color: #1f82f7;
        margin-right: 22px;
        cursor: pointer;
      }
    }
  }

  .swiper-container {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    cursor: pointer;

    img {
      width: 195px;
      height: 130px;
      background: #efefef;
      display: block;
    }

    .swiper-slideMess {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 195px;
      height: 72px;
      background: #f5f5f5;

      h4 {
        font-size: 16px;
        color: #0f1826;
      }

      p {
        font-size: 10px;
        color: #0f1826;
      }

      span {
        font-size: 12px;
        color: #ff0000;
      }
    }

    &:hover {
      img {
        box-shadow: 0px 0px 17px -7px #707070;
      }

      .swiper-slideMess {
        background: #157efb;

        h4 {
          color: #fff;
        }

        p {
          color: #fff;
        }

        span {
          color: #fff;
        }
      }
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    width: 40px;
    height: 40px;
    background: #e5e5e52e;
    border-radius: 50%;
    top: 200px;
  }

  .swiper-button-prev {
    left: -18px;
  }

  .swiper-button-next {
    right: -18px;
  }

  .swiper-button-prev:after,
  .swiper-container-rtl .swiper-button-next:after {
    font-size: 18px;
  }

  .swiper-button-next:after,
  .swiper-container-rtl .swiper-button-prev:after {
    font-size: 18px;
  }
}

.dmessages {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 53px;
  overflow: hidden;

  .swiperTopTitle {
    justify-content: space-between;
    align-items: flex-end;

    h2 {
      font-size: 16px;
      color: #1f82f7;
      padding-bottom: 10px;
      border-bottom: 1px solid #157efb;
    }

    .titleRight {
      align-items: flex-end;
      height: 20px;
      .titleMore {
        margin-left: 110px;
        font-size: 12px;
        color: #1f7de9;
        cursor: pointer;
      }
      i {
        color: #444444;
        margin-left: 110px;
        cursor: pointer;
      }

      span {
        font-size: 14px;
        font-weight: 400;
        color: #1f82f7;
        cursor: pointer;
      }

      .titleXie {
        margin: 0 5px;
      }
    }
  }

  .dmessagesImg {
    width: 100%;
    height: 300px;
    background: #efefef;
    margin: 28px 0 31px 0;

    img {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }

  .dmessagesBottom {
    display: flex;
    width: 1200px;
    // overflow: hidden;
    // justify-content: space-between;
    .dmessagesBottombox:nth-of-type(1) {
      margin-left: 0px;
    }
    .dmessagesBottombox {
      width: 216px;
      margin-left: 30px;
      img {
        width: 216px;
        height: 138px;
        background: #efefef;
        display: block;
        cursor: pointer;
      }

      .sdmessagesbotMes {
        cursor: pointer;
        width: 100%;
        height: 80px;
        color: #0f1826;
        text-align: center;
        background: #f5f5f5;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        h4 {
          width: 80%;
          font-size: 16px;
          margin-top: 6px;
          margin-bottom: 6px;
          font-weight: normal;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        p {
          // font-size: 10px;
          // font-weight: 400;
          font-size: 12px;
          color: #585858;
          margin-bottom: 6px;
        }

        span {
          font-size: 12px;
          font-weight: bold;
          color: #ff0000;
        }
      }
    }
    .dmessagesBottombox:hover {
      box-shadow: 0 0 10px 4px #c7c7c77e;
      .sdmessagesbotMes {
        background: #157efb;
        color: #fff;
        span {
          color: #fff;
        }
      }
      p {
        color: #fff;
      }
    }
  }

  .swiper-container {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    cursor: pointer;

    img {
      width: 195px;
      height: 130px;
      background: #efefef;
      display: block;
    }

    .swiper-slideMess {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 195px;
      height: 72px;
      background: #f5f5f5;

      h4 {
        font-size: 16px;
        color: #0f1826;
      }

      p {
        font-size: 10px;
        color: #0f1826;
      }

      span {
        font-size: 12px;
        color: #ff0000;
      }
    }

    &:hover {
      img {
        box-shadow: 0px 0px 17px -7px #707070;
      }

      .swiper-slideMess {
        background: #157efb;

        h4 {
          color: #fff;
        }

        p {
          color: #fff;
        }

        span {
          color: #fff;
        }
      }
    }
  }
}

.goods {
  background: #157dfb08;

  .goodsbox {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0 26px;

    .swiperTopTitle {
      justify-content: space-between;
      align-items: center;
      margin-bottom: 26px;
      .titleMore {
        margin-left: 110px;
        font-size: 12px;
        color: #1f7de9;
        cursor: pointer;
      }
      h2 {
        font-size: 16px;
        color: #1f82f7;
        padding-bottom: 10px;
        border-bottom: 1px solid #157efb;
      }

      i {
        color: #444444;
        cursor: pointer;
      }
    }
  }

  .goodsImg {
    flex-wrap: wrap;
    // justify-content: space-between;
    .goodsImgBox:nth-of-type(6n + 1) {
      margin-left: 0;
    }
    .goodsImgBox {
      // width: 189px;
      // height: 0;
      margin-left: 13px;
	  position: relative;
    }
    img:nth-child(1) {
      margin-left: 0;
    }
    img {
      width: 189px;
      height: 90px;
      background: #efefef;
      margin-bottom: 13px;
      cursor: pointer;
      box-shadow: 0px 0px 5px 2px #efefef;
    }
  }
}

.topNapbox {
  //width: 1200px;
  margin: 0 auto;
  top: 100px;
  // left: 16%;
  left: 5%;
  // transform: translate(-56%, 0);
  position: fixed;
  z-index: 10;

  .topNap {
    // width: 55px;
    width: 60px;
    // height: 387px;
    background: #fbfbfb;
    padding: 23px 0 9px;
    box-sizing: border-box;
    text-align: center;
    p:nth-child(1) {
      width: 41px;
    }
    p:nth-last-child(1) {
      width: 41px;
    }
    p:nth-child(4) {
      width: 47px;
    }
    p {
      padding: 0 7px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      color: #707070;
      display: block;
      // text-align: left;
      margin-bottom: 17px;
      // &:nth-last-of-type(1) {
      //   margin-bottom: 0;
      //   color: #157efb;
      //   i {
      //     display: block;
      //     margin-bottom: 9px;
      //   }
      // }
      &.active {
        // color: #fff !important;
        // background: #157efb;
        color: #157efb;
      }

      &:hover {
        color: #157efb;
      }
    }
  }
}
 .mask {
        position: absolute;
        background: rgba(101, 101, 101, 0.6);
        color: #ffffff;
        opacity: 0;
        top: 0;
        right: 0;
        width: 100%;
        height: 90px;
        border-radius: 10px;
        pointer-events: none;

        .maskContent {
            position: absolute;
            top: 50%;
            width: 100%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
        }

        p {
            text-align: center;
        }
    }
	.goodsImgBox:hover .mask {
	    opacity: 1;
	}
</style>



// WEBPACK FOOTER //
// src/components/threeShop/index.vue